import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

import ElementPlus from 'element-plus'
import  zhCn  from 'element-plus/es/locale/lang/zh-cn'
import * as ElementPlusIconsVue  from '@element-plus/icons-vue'
import 'element-plus/dist/index.css'
import '../public/css/global.css' 
import '../src/styles/index.css'
import $helper from './helper/helper';

// let theme = window.localStorage.getItem("theme");
// let cssPath = "";
// if(!theme){
//     theme="index"
// }
// if(theme=="index"){
//     cssPath="~@/assets/css/index.module.css"
    
// }else if(theme=="red"){
//     cssPath="./styles/index.css"
// }
// import(cssPath).then((module) => {
//     debugger
//     console.log('CSS 文件已成功加载'); 
// }).catch(error => {
//     debugger
//     console.error('加载 CSS 文件时发生错误:', error);
// });

const app = createApp(App);
// 注册所有图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}
app.use(router).use(ElementPlus,{locale:zhCn}).mount('#app')

//自定义指令permission，用于按钮权限控制
app.directive('permission', {
    mounted(el, binding) {
        if($helper.hasPermission(binding.value)==false){
            el.parentNode && el.parentNode.removeChild(el);
        }
    },
});

// 导航守卫
// 使用 router.beforeEach 注册一个全局前置守卫，判断用户是否登陆,是否需要二次验证
router.beforeEach((to, from, next) => {
    if (to.path === '/login') {
        next();
    } else {
        const token = localStorage.getItem('AuthorizationToken');
        const expires = localStorage.getItem('AuthorizationExpires');
        if(expires==null||Number.parseInt(expires)<=Math.round(new Date().getTime()/1000)){
            //token过期，需要重新登录
            next('/login');
            return;
        }
        if (token) {
            next();
        } else {
            next('/login');
        }
    }
});
